// extracted by mini-css-extract-plugin
export default {"formHeading":"TG-z","form":"UG-z","submitBtn":"VG-z","disabled":"WG-z","input":"XG-z","error":"YG-z","submitMsg":"ZG-z","signIn":"_G-z"};